import {Component, Input, OnInit} from '@angular/core';
import {MercadoriasService} from './mercadorias.service';
import {Funcoes} from "../funcoes";
import {Global} from "../global";
import {MercadoriasClassificacaoService} from "../mercadorias-classificacao/mercadorias-classificacao.service";

declare let $, swal: any;

@Component({
  selector: 'app-tabela-indices-classificacao',
  templateUrl: './tabela-indices-classificacao.component.html'
})
export class TabelaIndicesClassificacaoComponent implements OnInit {

  carregandoTabelaIndicesClassificacao: boolean = true;
  listIndicesClassificacao = [];

  @Input()
  id_mercadoria = null;

  @Input()
  id_defeito = null;

  constructor(
    private mercadoriasService: MercadoriasService,
    public func: Funcoes,
    public global: Global,
    private mercadoriasClassificacaoService: MercadoriasClassificacaoService
  ) {

  }

  ngOnInit() {
    this.mercadoriasClassificacaoService.get(null, {"id_mercadoria": this.id_mercadoria, "id_defeito": this.id_defeito}, null, {"ordem": "A"})
      .subscribe(data => {
          this.listIndicesClassificacao = data['Payload'];
          this.carregandoTabelaIndicesClassificacao = false;
        },
        error => {
          this.func.showErro(error.json());
          this.carregandoTabelaIndicesClassificacao = false;
        });
  }

  deleteIndiceClassificacao(indice) {
    let classificacoes = this.listIndicesClassificacao;
    let mercadoriasClassificacaoService = this.mercadoriasClassificacaoService;

    let self = this;

    swal({
        title: this.func.traduzir('front.voceTemCerteza'),
        text: this.func.traduzir('front.desejaDeletarIndiceClassificacao')+indice.nome,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: 'btn-danger',
        confirmButtonText: this.func.traduzir('front.confirmar'),
        cancelButtonText: this.func.traduzir('front.cancelar'),
        closeOnConfirm: true
      },
      function(){
        if(self.global.debug == true){
          console.log(classificacoes);
        }

        let index = classificacoes.indexOf(indice);
        classificacoes.splice(index, 1);

        mercadoriasClassificacaoService.apagar(indice.id)
          .subscribe(res => {
              self.listIndicesClassificacao = classificacoes;
            },
            err => {
              // Revert the view back to its original state
              classificacoes.splice(index, 0, indice);
              self.listIndicesClassificacao = classificacoes;

              self.func.showErro(err.json());
            });

      });
  }

  ordenouIndicesClassificacao(e){
    console.log(e);
    console.log(this.listIndicesClassificacao);

    for(let i in this.listIndicesClassificacao){
      console.log('indice', this.listIndicesClassificacao[i]);
      this.listIndicesClassificacao[i].ordem = parseInt(i)+1;
    }

    this.mercadoriasClassificacaoService.ordenaIndices(this.listIndicesClassificacao)
      .subscribe(json => {
        console.log(json);
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/mercadorias/tabela-indices-classificacao.component.ts